/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const SessionWithUser = zod
	.object({
		context: zod.string().describe('Session context'),
		insertedAt: zod.iso.datetime({ offset: true }).describe('Session creation time'),
		token: zod.string().describe('Base64 encoded token'),
		trackingId: zod.string().describe('Tracking ID for session'),
		user: zod
			.object({
				email: zod.email().describe('Email address'),
				environment_id: zod.string().nullable().describe('Environment ID'),
				fullName: zod.string().nullable().describe('Full name'),
				id: zod.string().describe('User ID'),
				organization_id: zod.string().nullable().describe('Organization ID')
			})
			.describe('A user account')
	})
	.describe('Session token with associated user');

export type SessionWithUser = zod.input<typeof SessionWithUser>;
export type SessionWithUserOutput = zod.output<typeof SessionWithUser>;
